/**
 *
 * FBAppointmentsPlanTab
 *
 */

import React, { memo, useCallback, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';



// styles
import './style.scss';

// antd component
import { Result, Button } from 'antd';

// layout components
import Preloader from 'components/Preloader';
import ErrorBoundary from 'engine/ErrorBoundary';

// components
import { NotificationSimple } from 'components/Notifications';

// Communication components
import {
  FBAnswersTabHeader,
} from 'components/Communications';
// inner components
import { FBAppointmentsPlan } from './components';


function FBAppointmentsPlanTab({
  type,
  loading,
  values,
  element,
  // plan data
  loadPlan,
  loadPlanSuccess,
  // actions
  onSave,
  onSent,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-forms-group-preview', 'tcf-fb-group-preview', 'tcf-fb-group-plan-tab', className);

  const [answersList, setAnswersList] = useState(values?.data || []);
  const [result, setResult] = useState([]);
  const [clickSave, setClickSave] = useState(false);
  const [clickSent, setClickSent] = useState(false);

  useEffect(() => {
    return () => {
      setAnswersList([])
      setResult([])
    }
  }, []);
  
  useEffect(() => {
    if (!!loadPlanSuccess) {
      setClickSent(false);
      setClickSave(false);
    }
  }, [loadPlanSuccess]);

  // Refresh current value based on parent`s states
  useEffect(() => {
    if (!!values && Object.keys(values)?.length > 0) {
      setAnswersList(values?.data);
    }
  }, [values]);

  const onSaveHandle = useCallback((data) => {
    !!onSave && onSave(data);
    setClickSave(true);
  }, [onSave]);

  const onSentHandle = useCallback((data) => {
    !!onSent && onSent(data);
    setClickSent(true);
  }, [onSent]);

  
  return !!values && (
    <div {...rest} className={childClassNames}>
      <div className='tcf-fb-group-plan-tab__wrapper'>
        <NotificationSimple
       //   Loading={loadPlan}
          Successful={loadPlanSuccess}
          message="Durant!"
          messageSuccess={clickSent ? `Communication envoyée avec succès` : `Communication sauveguardée`}
          description=""
          type={ clickSent ? "update" : "success"}
        />
        {loading && <Preloader />}
        {!loading && answersList?.length > 0 && (
          <ErrorBoundary>
            <FBAnswersTabHeader
              key="plan-header"
              title="Rendez-vous professeurs"
              type={type}
              data={answersList}
              showExport={answersList?.length == result?.length}
              extraActoins={[
                (<Button
                  key="appointments-save"
                  className="btn-save"
                  onClick={() => onSaveHandle(result)}
                  disabled={loadPlan || result?.length == 0}
                  loading={loadPlan && clickSave}
                >
                  Sauveguarder
                </Button>),
                (<Button
                  key="appointments-sent"
                  className="btn-sent"
                  onClick={() => onSentHandle(result)}
                  disabled={loadPlan || answersList?.length != result?.length}
                  loading={loadPlan && clickSent}
                >
                  Envoyer
                </Button>)
              ]}
            />
            <div className="tcf-fb-group-plan-tab__content">
              <FBAppointmentsPlan
                key={element?._id}
                values={answersList}
                onUpdate={resultArray => Array.isArray(resultArray) ? setResult(resultArray) : setResult([])}
              />
            </div>
          </ErrorBoundary>
        )}
        {!loading && answersList?.length == 0 && (
          <>
            <Result title="Malheureusement, il n'y a pas encore de réponses." />
          </>
        )}
      </div>

    </div>
  );
}

FBAppointmentsPlanTab.defaultProps = {
  type: 'appointments',
  loading: false,
  loadPlan: false,
  loadPlanSuccess: false,
};
FBAppointmentsPlanTab.propTypes = {
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.bool, PropTypes.array]),
  onSave: PropTypes.func,
  onSent: PropTypes.func,
};

export default memo(FBAppointmentsPlanTab);
